import client from '../../client'

export interface Params {
  code?: string
  code2?: string
  sno?: string
}

export interface Response {
  form: { [key: string]: string }
  bookData: {
    inputCode: string
    baitaiCode: string
    searchFlg: boolean
    serviceName: string
    presentSubject: string
    presentBody: string[]
  }
  masterData: {
    shiryouType: { [key: string /* 資料請求タイプID e.g. '1' */]: { name: string } }
    schoolType: { [key: string /* 学校ID e.g. 'D100001' */]: { name: string } }
    keitou: {
      [key: string /* 資料請求タイプID e.g. '1' */]: {
        [key: string /* 系統ID e.g. '101' */]: { name: string }
      }
    }
    area: {
      [key: string /* エリアID e.g. '1' */]: {
        name: string
        prefecture: { [key: string /* 都道府県ID e.g. '1' */]: { name: string } }
      }
    }
  }
  conditionData: {
    schoolTotal: { count: number }
    shiryouType: {
      [key: string /* 資料請求タイプID e.g. '1' */]: { name: string; count: number }
    }
    keitou: {
      [key: string /* 資料請求タイプID e.g. '1' */]: {
        [key: string /* 系統ID e.g. '101' */]: { name: string; count: number }
      }
    }
    area: {
      [key: string /* 資料請求タイプID e.g. '1' */]: {
        [key: string /* エリアID e.g. '1' */]: {
          name: string
          count: number
          prefecture: {
            [key: string /* 都道府県ID e.g. '1' */]: { name: string; count: number }
          }
        }
      }
    }
  }
}

export async function get(params?: Params) {
  return client.get<Response>('get_request_top_data', { params }).then(({ data }) => data)
}
